import { render, staticRenderFns } from "./ContentModal.vue?vue&type=template&id=48dfc744&"
import script from "./ContentModal.vue?vue&type=script&lang=js&"
export * from "./ContentModal.vue?vue&type=script&lang=js&"
import style0 from "./ContentModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports